import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Col } from 'antd'

const SearchLocationInput = (props: any) => {
  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);

  useEffect(() => {
      handleScriptLoad(setQuery, autoCompleteRef, props)
      setQuery(props?.address)
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // setting up the input value to main address
  useEffect(() => {
      return props.setAddress(query)
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  let autoComplete: any;

  const handleScriptLoad = (updateQuery: any, autoCompleteRef: any, props: any) => {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current
    );
    autoComplete.setFields(["address_components", "formatted_address", "plus_code", "vicinity"]);
    autoComplete.addListener("place_changed", () =>
      handlePlaceSelect(updateQuery, props)
    );
  }

  const handlePlaceSelect = async (updateQuery: any, props:any) => {
    const addressObject = await autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
    // setting up data
    if (addressObject && addressObject.address_components) {
      addressObject.address_components.map(async (item: any) => {
        if (item.types[0] === 'route') {
          const firstReference = query.split(',')[0];
          setQuery(firstReference)
        }
        if (item.types[0] === 'locality') props.setCity(item.long_name)
        if (item.types[0] === 'country') {
          const [ct] = props.countryData.filter((country: string) => country.includes(item.long_name))
          props.setCountry(ct)
        }
        if (item.types[0] === 'administrative_area_level_1') {
          const [st] = props.states.filter((state: string) => state.includes(item.long_name))
          props.setState(st)
        }
        item.types[0] === 'postal_code' ? props.setZip(item.long_name) : props.setZip('')
      })
    }
    return props.validate()
  }

  return (
    <>
    <Col span={24}>
      {
        <Form.Item
          label="Address"
          name='address'
          rules={[
            {
              required: props.tabValue === 0,
              message: 'Please enter an Address',
            },
          ]}
        >
          <Input 
            className="d-none" 
            value={query} 
            onChange={(event) => {setQuery(event.target.value); props.setAddress(event.target.value)}} 
            onSubmit={e =>  e.preventDefault() }
            placeholder='Add an Address'
          />
          <input
            className="autocomplete-field"
            ref={autoCompleteRef}
            onChange={(event) => {setQuery(event.target.value); props.setAddress(event.target.value)}}
            value={query}
            placeholder=""
            id="search"
            type="search"
            onSubmit={e =>  e.preventDefault() }
          />
        </Form.Item>
        // placeholder input to simulate magnificent glass material UI effect
      }
    </Col>
    </>
  );
}

export default SearchLocationInput;
